import API from 'services/api';

import { notify } from 'utils/reduxUtils';

import * as types from './types';

/**
 * Synchronously updates user record with new values
 * @param {Object} values
 */
export const receiveUser = (values) => ({
  type: types.RECEIVE_USER,
  payload: values,
});

export const fetchProfile = {
  request: () => ({
    type: types.PROFILE_FETCH_REQUEST,
  }),
  error: notify(
    (error) => ({
      type: types.PROFILE_FETCH_ERROR,
      payload: error,
    }),
    'Error fetching profile.',
  ),
};

export const patchConnectedAccount = (groupId, data) => ({
  type: types.PATCH_CONNECTED_ACCOUNT,
  payload: API.payments.patchConnectedAccount(groupId, data),
});

export const receivePaperlessTerms = (paperlessTerms) => {
  return {
    type: types.PAPERLESS_TERMS,
    payload: { paperlessTerms: paperlessTerms },
  };
};

export const receiveAccessToken = (accessToken) => ({
  type: types.RECEIVE_ACCESS_TOKEN,
  payload: { accessToken },
});

export const receiveGroup = (payload) => ({
  type: types.RECEIVE_GROUP,
  payload,
});
